// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2KiTm","icon":"SortAdornment_icon__ciGPT","up":"SortAdornment_up__3I4Lw","down":"SortAdornment_down__4UW32","active":"SortAdornment_active__33zAf"};